<template>
    <div id="app">
        <template  v-if="seen">
            <div class="header" style="display: flex;align-items: center;">
                <div class="logo_img" @click="logoClick">
                    <div style="display:flex; align-items: center; float:left; height: 65px;">
                        <!-- <div class="header-logo">
                            <img id="header-img" src="../../static/slider/logo1.png" >
                        </div> -->
                    </div>
                    <div style="display:flex; float:left; height: 65px;">
                        <div class="header-important">
                            <div class="company_name">北京富电易充科技有限公司</div>
                            <div class="header-title company_name"></div>
                        </div>
                    </div>
                </div>
                <div id="menu_index" class="menu_index">
                    <!-- web端菜单导航 background-color="#18D1BB" active-text-color="#fff" {{ $t("login.loginTitle") }}-->
                    <el-menu v-if="seen" :default-active="$store.state.id" :active="$store.state.id"  class="el-menu-demo" text-color="#333" style="height: 40px; border:0;" mode="horizontal" @select="handleSelect" >
                        <el-menu-item index="1" class="header-title">首页 </el-menu-item>
                        <!-- <el-submenu index="2">
                            <template slot="title">公司介绍</template>
                            <el-menu-item index="2-3"   class="totalClass">公司介绍</el-menu-item>
                            <el-menu-item index="2-1"  class="totalClass">公司简介</el-menu-item>
                            <el-menu-item index="2-2"  class="totalClass">大事记</el-menu-item>
                            
                        
                        </el-submenu> -->
                        <!-- <el-submenu index="3" class="header-title"  >
                            <template slot="title">新闻中心</template>
                            <el-menu-item index="3-3" class="totalClass">新闻中心</el-menu-item>
                            <el-menu-item index="3-1" class="totalClass">公司新闻</el-menu-item>
                            <el-menu-item index="3-2" class="totalClass">媒体新闻</el-menu-item>
                        </el-submenu> -->
                        <!-- <el-submenu index="4" class="header-title" >
                            <template slot="title">业务领域</template>
                            <el-menu-item index="4-7" class="totalClass">业务领域</el-menu-item>
                            <el-menu-item index="4-1" class="totalClass">充电桩生产及销售业务</el-menu-item>
                            <el-menu-item index="4-2" class="totalClass">充电桩建设及运营业务</el-menu-item>
                            <el-menu-item index="4-3" class="totalClass">传感光伏业务</el-menu-item>
                            <el-menu-item index="4-4" class="totalClass">BIPV(光伏业务)</el-menu-item>
                            <el-menu-item index="4-5" class="totalClass">共享出行分时租赁</el-menu-item>
                            <el-menu-item index="4-6" class="totalClass">充电运营平台小程序解决方案</el-menu-item>
                        </el-submenu> -->
                        <!-- <el-menu-item index="5" class="header-title">集团公告</el-menu-item> -->
                        <!-- <el-menu-item index="6" class="header-title">合作伙伴</el-menu-item> -->
                        <el-menu-item index="7" class="header-title">联系我们</el-menu-item>
                    </el-menu>
                    <!-- 手机端菜单导航 v-bind:style="{backgroundColor:'#409EFF'}" -->
                    <el-menu v-if="!seen" :default-active="activeIndex" class="el-menu-demo" menu-trigger="click" text-color="#333" style="height: 65px; border:0;" mode="horizontal" @select="handleSelectMobile">
                        <el-submenu index="1" class="header-title mobile_menu">
                            <template slot="title">{{currentMenu}}</template>
                            <el-menu-item index="1" class="header-title">首页</el-menu-item>
                            <!-- <el-menu-item index="2-2" class="header-title">生鲜果蔬</el-menu-item> -->
                            <!-- <el-menu-item index="2-1" class="header-title">业务介绍</el-menu-item> -->
                            <!-- <el-menu-item index="3" class="header-title">合作伙伴</el-menu-item> -->
                            <!-- <el-menu-item index="4" class="header-title">公司产品</el-menu-item> -->
                            <el-menu-item index="5" class="header-title">关于我们</el-menu-item>
                        </el-submenu>
                    </el-menu>
                </div>
                <!-- <div v-if="seen" style="float: right; display: flex;align-items: center; height: 100%;">
                    <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
                    <el-button type="primary" class="header-title" @click="register" round>注册</el-button>
                </div> -->
            </div>
        </template>

        <template v-if="!seen">
            <div class="" style="padding-top: 10px;">
                <div style="display:flex; align-items: center; height: 65px;">
                    <div class="logoMobLogo" @click="logoClick">
                        <!-- <img id="" src="../../static/slider/logo1.png" > -->
                        <div class="company_name">北京富电易充科技有限公司</div>
                    </div>
                </div>
                   
            </div>
            <van-tabs @click="tabsClick">
                <van-tab v-for="(item,index) in tabsData" :title="item.title" :key="index">
                   
                </van-tab>
            </van-tabs>
        </template>

        <div class="container" style="clear: both;">
            <router-view ></router-view>
        </div>

        <template v-if="!seen">
            <div class="mob-footer">
                <!-- <div class="mob-join">
                    <div class="mob-joinText">加入我们</div>
                    <div class="mob-joinText">
                        中文版<span style="margin:0 8px">|</span>English
                    </div>
                </div> -->
                <div class="mob-beian">
                    <a href="https://beian.miit.gov.cn" target="_blank">京ICP备2023006901号-4</a>|CopyRight© 2023  集团
                </div>
            </div>
        </template>

        <!-- <div style="width: 90%;margin: 20px auto;">
            <div style="height:1px;padding:0;background-color:#999;">
            </div>
        </div> -->
        <!-- <div style="width: 90%;margin: 20px auto;">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12">
                    <p class="footer_font">邮箱：765113577@163.com</p>
                    <div style="margin: auto;" class="footer_font">
                        互联网ICP备案：19029919
                    </div>
                    <div style="margin: auto;" class="footer_font">
                       北京富电易充科技有限公司版权所有
                    </div>
                </el-col>
                
            </el-row>
        </div>
        <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
            <p style="font-size: 0.625em; font-weight: bold">TOP</p>
            <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
        </div> -->
    </div>
</template>

<script>
    import {mapstate,mapMutations} from 'vuex'
    import { Tab, Tabs } from 'vant';
    export default {
        name: "Layout",
        data() {
            return {
                activeIndex: '1',
                company:{
                    qrcode: require("../../static/other/公众号二维码.jpg"),
                },
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页',
                tabsData:[
                    {id:"1",title:"首页",index:"1"},
                    // {id:"2",title:"公司介绍",index:"2-3"},
                    // {id:"3",title:"新闻中心",index:"3-3"},
                    // {id:"4",title:"业务领域",index:"4-7"},
                    // {id:"5",title:"集团公告",index:"5"},
                    // {id:"6",title:"合作伙伴",index:"6"},
                    {id:"7",title:"联系我们",index:"7"},
                ]
            };
        },
        computed:{
          
        },
        methods: {
            tabsClick(e){
                let tabs = ""
                console.log(e)
                this.tabsData.map((item,index)=>{
                    if(index == e){
                        tabs = item
                    }
                })
                console.log(tabs)
                let key = tabs.index
                switch(key){
                    case '1':
                    this.$router.push({name: "Index"});
                        break;
                    case '2-1':
                        this.$router.push({path: "introduction?id=1"});
                        break;  
                    case '2-2':
                        this.$router.push({path: "thing?id=2"});
                        break;
                    case '2-3':
                        this.$router.push({path: "mobIntroduce"});
                        break; 
                    case '3-3':
                        this.$router.push({path: "mobNews"});
                        break; 
                    case '4-7':
                        this.$router.push({path: "mobBusiness"});
                        break;
                    case '5':
                        this.$router.push({path: "mobNotice"});
                        break;
                    case '6':
                        this.$router.push({path: "mobPartner"});
                        break;
                    case '7':
                        this.$router.push({path: "mobConcact"});
                        break;
                }
            },
            handleSelect(key) {
                console.log(key)
                // let activeIndex = key.split("-")
                // console.log(activeIndex)
                // this.activeIndex = key
                this.$store.commit('newSet',key)
                this.activeIndex = this.$store.state.id
                console.log( this.activeIndex )
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        break;
                    case '2-1':
                        this.$router.push({path: "introduction?id=1"});
                        break;
                    case '2-2':
                        this.$router.push({path: "thing?id=2"});
                        break;
                    case '2-3':
                        this.$router.push({path: "introduce?id=3"});
                        break;
                        // <el-menu-item index="3-3" class="totalClass">新闻中心</el-menu-item>
                        // <el-menu-item index="3-1" class="totalClass">公司新闻</el-menu-item>
                        // <el-menu-item index="3-2" class="totalClass">媒体新闻</el-menu-item>
                    case '3-1':
                        this.$router.push({path: "news?type=2"});                      
                        break;
                    case '3-2':
                        this.$router.push({path: "news?type=1"});                      
                        break;
                    case '3-3':
                        this.$router.push({path: "news?type=3"});                      
                        break;
                    case '4-7':
                        this.$router.push({name: "businessArea"});
                       
                        break;
                    case '4-1':
                        this.$router.push({path: "areaDetails?id=1",query:{data:{id:'1',t:Date.now()}}});                      
                        break;
                    case '4-2':
                        this.$router.push({path: "areaDetails?id=2",query:{data:{id:'2'}}});                      
                        break;
                    case '4-3':
                        this.$router.push({path: "areaDetails?id=3",query:{data:{id:'3',t:Date.now()}}});                      
                        break;
                    case '4-4':
                        this.$router.push({path: "areaDetails?id=4",query:{data:{id:'4'}}});                      
                        break;
                    case '4-5':
                        this.$router.push({path: "areaDetails?id=5",query:{data:{id:'5'}}});                      
                        break;
                    case '4-6':
                        this.$router.push({path: "areaDetails?id=6",query:{data:{id:'6'}}});                      
                        break;
                    case '5':
                        this.$router.push({path: "notice"});
                       
                        break;
                    case '6':
                        this.$router.push({path: "partner"});
                        break;
                    case '7':
                        this.$router.push({path: "contact"});
                        break;
                       
                }
            },
            
            handleSelectMobile(key) {
                switch (key){
                    case '1':
                        this.$router.push({name: "Index"});
                        this.currentMenu='首页';
                        break;
                    case '2-1':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品微观";
                        this.currentMenu='首页';
                        break;
                    case '2-2':
                        this.$router.push({name: "Fruit"});
                        this.currentMenu='生鲜果蔬';
                        break;
                    case '2-3':
                        this.$router.push({name: "Fashion"});
                        break;
                    case '3':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#产品特点";
                        this.currentMenu='首页';
                        break;
                    case '4':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#合作伙伴";
                        this.currentMenu='首页';
                        break;
                    case '5':
                        this.$router.push({name: "Index"});
                        window.location.hash = "#关于我们";
                        this.currentMenu='首页';
                        break;
                }
            },
            handleScroll(){
                this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
                if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
                    // this.$refs.btn.style.display = 'block';
                }else{
                    // this.$refs.btn.style.display = 'none'
                }
            },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            login(){
                window.open('https://admin.fastice-tech.com/login')
            },
            register(){
                window.open('https://admin.fastice-tech.com/registe')
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            }
        },
        mounted() {
            this.menuSeen()
            window.addEventListener('scroll', this.handleScroll)
        },
        created(){
           
          
        }
    }
</script>


<style>
.van-tabs__line{
    display: none !important;
}
.mob-beian{
    color:#333;
    font-size:11px;
    padding:12px;
    text-align:center;
}
.mob-joinText{
    color:#fff;
    font-size:12px;
}
.mob-join{
    background-color:#333;
    padding:12px 27px;
    display:flex;
    justify-content:space-between;
}
.logoMobLogo{
    padding-left:10px ;
    display: flex;
    align-items: center;
}
.logoMobLogo img{
    width: 60px;
    height: 60px;
}
.menu_index ul.el-menu--horizontal{
    height: 44px !important;
}
.el-menu--popup{
    padding: 0 !important;
}
li.totalClass,.el-menu--popup-bottom-start{
    /* background-color: #18D1BB !important; */
}
li.totalClass{
    border-bottom: 2px solid #fff;
    /* color: #fff !important; */
}
.van-tabs__line{
    background-color: #00A5B1 !important;
}
li.totalClass:hover{
    background: #00A5B1  !important;
    color: #fff !important;
}
.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
    color: #303133;
}
    .el-menu-item:hover {
        background: #18D1BB  !important;
        color: #fff !important;
    }
    .el-submenu:hover{
        background: #18D1BB  !important;
        color: #fff !important;
    }
    .el-menu--horizontal>.el-menu-item.is-active {
        border-bottom: none !important;
        color: #303133;
    }
    .el-menu--horizontal>.el-menu-item{
        height: 44px !important;
        line-height: 44px !important;
    }
    .el-menu-item, .el-submenu__title{
        height: 44px !important;
        line-height: 44px !important;
    }
    .el-submenu__title{
        height: 44px !important;
        line-height: 44px !important;
    }
    .menu_index .el-menu--horizontal>.el-submenu .el-submenu__title{
        height: 44px !important;
        line-height: 44px !important;
    }
    .menu_index .el-menu--horizontal>.el-menu-item {
        height: 44px !important;
        line-height: 44px !important;
        margin-right: 10px;
    }
.el-submenu__title:hover {
  background: #18D1BB  !important;
  color: #fff !important;
}
.el-menu-item.is-active {
  background: #18D1BB !important;
  color: #fff !important;
}
.el-submenu__title.is-active {
  background: #18D1BB !important;
  color: #fff !important;
}
.logo_img{
        float:left;
        width: 30%;
        cursor: pointer;
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        /* font-size: 1em; */
    }
    .company_name{
        font-weight: normal;
        font-size: 1.3em;
        /* font-weight: 600; */
    }
    .footer_font{
        font-size: 1em;
    }
    #menu_index{
        /* float: left; height: 100% */
    }
    .header{
        margin: auto;
        width: 90%;
        height: 75px;
        /*background: #F56C6C;*/
    }
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
        .mobile_menu{

        }
    }
    #header-img{
        width: 55px;
        height: 55px;
        float: left;
        margin: auto;
    }
    .header-logo{
        height: 50px;
        width: 50px;
        align-self: center;
    }
    .header-important{
        float: left;
        margin-left: 6px;
        align-self: center;
    }

    .footer{
        display: flex;
        align-items: center;
        margin: 10px auto;
        width: 90%;
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
</style>